<template>
    <div>
        <div class="card">
            <TabView>
                <TabPanel header="Reporte ISR">
                    <reporte-isr></reporte-isr>
                </TabPanel>
                <TabPanel header="Reporte Trabajadores">
                    <reporte-trabajadores></reporte-trabajadores>
                </TabPanel>
                <TabPanel header="Reporte por Conceptos">
                    <reporte-conceptos></reporte-conceptos>
                </TabPanel>
                <TabPanel header="Reporte Origen de Recurso">
                    <reporte-origen-recurso></reporte-origen-recurso>
                </TabPanel>
                <TabPanel header="Reporte Capítulo 1000">
                    <reporte-mil></reporte-mil>
                </TabPanel>
            </TabView>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";

    import ReporteIsr from './ReporteIsr.vue'
    import ReporteTrabajadores from './ReporteTrabajadores.vue'
    import ReporteConceptos from './ReporteConceptos.vue'
    import ReporteOrigenRecurso from './ReporteOrigenRecurso.vue'
    import ReporteMil from './ReporteMil.vue'

    export default {
        components: {
            ReporteIsr,
            ReporteTrabajadores,
            ReporteConceptos,
            ReporteOrigenRecurso,
            ReporteMil,
        },
        data() {
            return {
                fechaI: new Date(),
                fechaF: new Date(),
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
        },
        created() {

        },
        methods: {

        },
    }
</script>